/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_typing_hub_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The average is around 40 WPM. 60–70 WPM is fast, and professional typists often exceed 80–100 WPM. Accuracy matters as much as raw speed.`)
};

const es_typing_hub_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`El promedio ronda las 40 WPM. 60–70 WPM es rápido, y los mecanógrafos profesionales suelen superar las 80–100 WPM. La precisión importa tanto como la velocidad.`)
};

const de_typing_hub_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Der Durchschnitt liegt bei etwa 40 WPM. 60–70 WPM sind schnell, und professionelle Vielschreiber erreichen oft 80–100 WPM. Genauigkeit zählt genauso viel wie die reine Geschwindigkeit.`)
};

const nl_typing_hub_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Het gemiddelde ligt rond de 40 WPM. 60-70 WPM is snel, en professionele typisten halen vaak meer dan 80-100 WPM. Nauwkeurigheid is net zo belangrijk als pure snelheid.`)
};

const fr_typing_hub_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La moyenne se situe autour de 40 WPM. 60 à 70 WPM est rapide, et les dactylographes professionnels dépassent souvent 80 à 100 WPM. La précision compte autant que la vitesse brute.`)
};

const it_typing_hub_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La media è di circa 40 WPM. 60–70 WPM è veloce, e i dattilografi professionisti superano spesso 80–100 WPM. La precisione conta quanto la velocità pura.`)
};

const pt_br2_typing_hub_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A média é de cerca de 40 WPM. 60–70 WPM é rápido, e digitadores profissionais costumam superar 80–100 WPM. A precisão importa tanto quanto a velocidade pura.`)
};

const pt_typing_hub_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A média ronda os 40 WPM. 60–70 WPM é rápido, e os dactilógrafos profissionais ultrapassam frequentemente os 80–100 WPM. A precisão importa tanto quanto a velocidade pura.`)
};

const ja_typing_hub_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`平均は約40WPMです。60〜70WPMは速い部類に入り、プロのタイピストは80〜100WPMを超えることも珍しくありません。速さだけでなく正確率も同じくらい重要です。`)
};

const zh_typing_hub_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`平均水平约为40 WPM。60–70 WPM算快，专业打字员通常能超过80–100 WPM。准确率与原始速度同样重要。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const typing_hub_faq2_a = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.typing_hub_faq2_a(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("typing_hub_faq2_a", locale)
	if (locale === "en") return en_typing_hub_faq2_a(inputs)
	if (locale === "es") return es_typing_hub_faq2_a(inputs)
	if (locale === "de") return de_typing_hub_faq2_a(inputs)
	if (locale === "nl") return nl_typing_hub_faq2_a(inputs)
	if (locale === "fr") return fr_typing_hub_faq2_a(inputs)
	if (locale === "it") return it_typing_hub_faq2_a(inputs)
	if (locale === "pt-BR") return pt_br2_typing_hub_faq2_a(inputs)
	if (locale === "pt") return pt_typing_hub_faq2_a(inputs)
	if (locale === "ja") return ja_typing_hub_faq2_a(inputs)
	return zh_typing_hub_faq2_a(inputs)
};